import { Component } from '@angular/core';

@Component({
  selector: 'locker-icon',
  standalone: true,
  imports: [],
  templateUrl: './locker.component.html',
  styleUrls: ['./locker.component.scss'],
})
export class LockerIcon {
}
